module.exports = __webpack_public_path__ + "static/assets/579cb7424aded0b5b2e4da61d86728f7.svg";